module.exports = __webpack_public_path__ + "img/modelshow05-3.8a48d07d.png";